import script from "./RecipeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeCard.vue?vue&type=script&setup=true&lang=js"

import "./RecipeCard.vue?vue&type=style&index=0&id=1840b6e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1840b6e6"]])

export default __exports__